import type { NskResponse } from "~/models/Api";
import type {
	UpdateParams,
	WithdrawParams
} from "~/models/DealPartnerAssignment";
import { putRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const paths = {
	update: (dealId: number) =>
		generatePath("/vendors/deals/:deal_id/deal_partner_assignment", {
			deal_id: dealId
		}),
	withdraw: (dealId: number) =>
		generatePath("/vendors/deals/:deal_id/deal_partner_assignment/withdraw", {
			deal_id: dealId
		})
};

export const update = async (
	dealId: number,
	params: UpdateParams
): Promise<NskResponse> => putRequest(paths.update(dealId), params);

export const withdraw = async (
	dealId: number,
	params: WithdrawParams
): Promise<NskResponse> => putRequest(paths.withdraw(dealId), params);

export const withdrawSelf = async (dealId: number): Promise<NskResponse> =>
	putRequest(paths.withdraw(dealId), {});
